import { Button, Modal, Typography } from 'antd';

export interface UnsavedChangesDialogProps {
  open: boolean;
  /** «Сохранить черновик» для DRAFT, «Сохранить» для перепроведения POSTED. */
  saveLabel: string;
  saving?: boolean;
  onSave: () => void;
  onDiscard: () => void;
  onCancel: () => void;
}

/** §8.7 «Закрытие с несохранёнными изменениями»: Сохранить(-черновик) / Не сохранять / Отмена. */
export function UnsavedChangesDialog({ open, saveLabel, saving, onSave, onDiscard, onCancel }: UnsavedChangesDialogProps) {
  return (
    <Modal
      title="Есть несохранённые изменения"
      open={open}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Отмена
        </Button>,
        <Button key="discard" danger onClick={onDiscard}>
          Не сохранять
        </Button>,
        <Button key="save" type="primary" loading={saving} onClick={onSave}>
          {saveLabel}
        </Button>,
      ]}
    >
      <Typography.Text>Закрыть без сохранения?</Typography.Text>
    </Modal>
  );
}
